import {
  Box,
  CircleHelp,
  ClipboardList,
  DraftingCompass,
  ListChecks,
  MessageCircleQuestion,
  Settings2,
  type LucideIcon,
} from 'lucide-react';
import { SLASH_COMMANDS } from '../types/chat';

/**
 * Keyed on the mode's own `icon` field rather than its id, so a mode added to
 * the slice picks up an icon by naming one. The two maps this replaced were
 * keyed on id and listed only five of the seven modes, so `verification` and
 * `cad` both fell back to the Q&A icon — in the picker and in the chip.
 */
const MODE_ICONS: Record<string, LucideIcon> = {
  help: CircleHelp,
  settings: Settings2,
  question_answer: MessageCircleQuestion,
  architecture: DraftingCompass,
  assessment: ClipboardList,
  verified: ListChecks,
  view_in_ar: Box,
};

export const getModeIcon = (icon?: string): LucideIcon =>
  (icon && MODE_ICONS[icon]) || MessageCircleQuestion;

/** The slash command that switches to a mode, e.g. "/plan". */
export const getModeCommand = (modeId: string): string | undefined =>
  SLASH_COMMANDS.find((command) => command.modeId === modeId)?.command;
